<template>
    <svg
        xmlns="http://www.w3.org/2000/svg"
        width="20"
        height="20"
        viewBox="0 0 20 20"
        fill="none"
    >
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M8.91797 11.166C9.47905 10.443 10.6018 10.4683 11.127 11.2373C11.1494 11.2657 11.171 11.2953 11.1895 11.3271L14.3193 16.7471C14.8485 17.6635 14.186 18.8064 13.1299 18.8066H6.86914C5.81353 18.806 5.15107 17.6632 5.67969 16.7471L8.81055 11.3271L8.91797 11.166ZM7.08984 17.3066H12.9102L9.99902 12.2666L7.08984 17.3066Z"
            fill="#8E8E93"
        />
        <path
            d="M1.33789 7.02832C1.41241 6.62103 1.80269 6.35153 2.20996 6.42578L18.0586 9.3252C18.466 9.39975 18.7367 9.79079 18.6621 10.1982C18.5875 10.6056 18.1964 10.8753 17.7891 10.8008L1.94043 7.90039C1.53325 7.82569 1.2635 7.43557 1.33789 7.02832Z"
            fill="#8E8E93"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M15.5557 1.19629C17.3505 1.19635 18.8056 2.65146 18.8057 4.44629C18.8057 6.24118 17.3505 7.69623 15.5557 7.69629C13.7607 7.69629 12.3057 6.24121 12.3057 4.44629C12.3057 2.65142 13.7608 1.19629 15.5557 1.19629ZM15.5557 2.69629C14.5892 2.69629 13.8057 3.47985 13.8057 4.44629C13.8057 5.41279 14.5892 6.19629 15.5557 6.19629C16.5221 6.19623 17.3057 5.41275 17.3057 4.44629C17.3056 3.47988 16.5221 2.69635 15.5557 2.69629Z"
            fill="#8E8E93"
        />
        <path
            fill-rule="evenodd"
            clip-rule="evenodd"
            d="M3.61133 0.640625C4.9458 0.640801 6.02723 1.72314 6.02734 3.05762C6.02717 4.39205 4.94576 5.47346 3.61133 5.47363C2.2768 5.47358 1.19451 4.39212 1.19434 3.05762C1.19445 1.72306 2.27676 0.640683 3.61133 0.640625ZM3.61133 2.14062C3.10519 2.14068 2.69445 2.55149 2.69434 3.05762C2.69451 3.56369 3.10522 3.97358 3.61133 3.97363C4.11733 3.97346 4.52717 3.56362 4.52734 3.05762C4.52723 2.55156 4.11737 2.1408 3.61133 2.14062Z"
            fill="#8E8E93"
        />
    </svg>
</template>
